import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3c0940fa&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.css?vue&type=style&index=0&id=3c0940fa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0940fa",
  null
  
)

export default component.exports